import { useEffect } from "react";

const useNumericInput = () => {
  useEffect(() => {
    const handleInput = (e) => {
      const input = e.target;

      if (
        !input ||
        !input.classList ||
        !input.classList.contains("only-numeric")
      ) {
        return;
      }

      let value = input.value.replace(/\D/g, "");

      const maxLength = input.getAttribute("data-maxlength");
      if (maxLength) {
        value = value.slice(0, Number(maxLength));
      }

      if (input.value !== value) {
        input.value = value;
      }
    };

    document.addEventListener("input", handleInput);
    return () => document.removeEventListener("input", handleInput);
  }, []);
};

export default useNumericInput;